export const validEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/)